import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-list',
  templateUrl: './widget-list.component.html',
  styleUrls: ['./widget-list.component.sass']
})
export class WidgetListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
